<script setup>
    import { useI18n } from 'vue-i18n';
    import IconLifecyrcle from "./IconLifecycle.vue";
    import { computed } from 'vue';

    const { t } = useI18n();

    const props = defineProps({
        iconOrderCode: {
            type: String,
            default: null,
        },

        text: {
            type: String,
            default: null,
        },

    });

    const descriptionText = computed(() => {
        let text = "";
        if(props.text !== null && props.text !== "") {
            return t(props.text);
        }
        return text;
    });

</script>

<template>
    <div class="icon-description">
        <IconLifecyrcle :icon-class="iconOrderCode" />
        <span class="description">
            {{ descriptionText }}
        </span>
    </div>
</template>
